const user = (DataBase, Datatype) => {
	const User = DataBase.new(
		{
			name: Datatype.STRING,
			email: Datatype.STRING,
			ativo: Datatype.BOOLEAN,
		},
		{
			tracked: true,
			dateLogs: true,
			softDelete: true,
			collection: "user",
			model: "User",
		}
	);

	User.defaults = {
		ativo: true,
	};

	User.relate = (models) => [
		{
			model: models.User,
			fk: "id_user",
			name: "usuario",
		},
	];

	return User;
};

export default user;
